export interface GoogleFormsIFrameProps {
  url: string;
  height?: string | number;
}

export function GoogleFormsIFrame(props: GoogleFormsIFrameProps) {
  const { url, height = "100vh" } = props;

  return (
    <iframe
      src={url}
      style={{
        height: `${typeof height === "number" ? `${height}px` : height}`,
        backgroundColor: "transparent",
      }}
      width="100%"
      height={height}
      frameBorder="no"
      scrolling="auto"
    />
  );
}
